import { TherapistAPI, type Therapist } from "../../therapist";

/** Save the concept and amount a new payment starts from. */
export async function saveDefaultPaymentLine(
    therapistId: string,
    line: Pick<Therapist, "default_payment_concept" | "default_payment_amount">
): Promise<void> {
    await TherapistAPI.update(therapistId, line);
}
